import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IExchangeOfferResponse, IPreExchangeOperationRequest, IPreExchangeOperationResponse, IQuickExchangeOfferRequest } from "../../Orchestrator/Types/Index";
import { IExternalPaymentRequest, IExternalPaymentResponse, IZeroPaymentResponse } from "../../Orchestrator/Types/Interface/IPayment";
import { ExternalPaymentResponse } from "../../Orchestrator/Types/Types/BookingTypes";

export async function postExchangeOffer(
    exchangeOfferRequest: IQuickExchangeOfferRequest,
    bookingId: string,
    showErrorToast: boolean = true,
    showLoader: boolean = true
): Promise<IApiResponse<IExchangeOfferResponse>> {

    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.bookingsExchangeOffers(bookingId)}`;

    return await apiRequest<IExchangeOfferResponse>(
        endpoint,
        'POST',
        { body: JSON.stringify(exchangeOfferRequest) },
        "none",
        undefined,
        undefined,
        showLoader,
        showErrorToast
    );
}

export async function postPreExchangeOperation(
    preExchangeRequest: IPreExchangeOperationRequest,
    bookingId: string
): Promise<IApiResponse<IPreExchangeOperationResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.preExchangeOperationStart(bookingId)}`;
    return await apiRequest<IPreExchangeOperationResponse>(endpoint, 'POST', {
        body: JSON.stringify(preExchangeRequest),
    });
}


export async function postExternalPayment(
    externalPaymentRequest: IExternalPaymentRequest,
    bookingId: string
): Promise<IApiResponse<IExternalPaymentResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.externalPaymentAPI(bookingId)}`;
    return await apiRequest<ExternalPaymentResponse>(endpoint, 'POST', {
        body: JSON.stringify(externalPaymentRequest),
    });
}

export async function postZeroPayment(
    zeroPaymentRequest: any,
    bookingId: string
): Promise<IApiResponse<IZeroPaymentResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.zeroPaymentAPI(bookingId)}`;
    return await apiRequest<IZeroPaymentResponse>(endpoint, 'POST', {
        body: JSON.stringify(zeroPaymentRequest),
    });
}

export async function cancelExchangeOffers(
    bookingId: string,
    exchangeOperationId: string
): Promise<IApiResponse<IExchangeOfferResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.cancelExchangeOffers(bookingId, exchangeOperationId)}`;
    return await apiRequest<IExchangeOfferResponse>(endpoint, 'DELETE',
        // {body: JSON.stringify(zeroPaymentRequest)}
    );
}